export function printTime(timeInSeconds: number): string {
  const minutes = Math.floor(timeInSeconds / 60);
  const roundedSeconds = Math.round(timeInSeconds);
  const seconds = roundedSeconds - 60 * minutes;
  const time = seconds < 10 ? `${minutes}:0${seconds}` : `${minutes}:${seconds}`;
  return time;
}
